
import { BallPiece, Vector2D, ShapeType } from '../../types';
import { ShapeUtils } from '../physics/ShapeUtils';

export const BallBreakAnimation = {
  createPieces: (
    pos: Vector2D,
    radius: number,
    color: string,
    count: number,
    shape: ShapeType,
    now: number,
    duration: number
  ): BallPiece[] => {
    const pieces: BallPiece[] = [];
    for (let i = 0; i < count; i++) {
      const angle = Math.random() * Math.PI * 2;
      const dist = Math.random() * radius * 0.8;
      const speed = 3 + Math.random() * 8;
      
      // Shard position offset from center
      const offsetX = Math.cos(angle) * dist;
      const offsetY = Math.sin(angle) * dist;

      pieces.push({
        id: Math.random().toString(),
        pos: { x: pos.x + offsetX, y: pos.y + offsetY },
        vel: {
          x: (Math.cos(angle) * speed) + (Math.random() - 0.5) * 6,
          y: (Math.sin(angle) * speed) - 10 + (Math.random() - 0.5) * 6 // Stronger upward burst
        },
        radius: radius * (0.1 + Math.random() * 0.3),
        color,
        startTime: now,
        duration,
        angle: Math.random() * Math.PI * 2,
        spin: (Math.random() - 0.5) * 0.6,
        shape: (['TRIANGLE', 'SQUARE', 'PENTAGON', 'HEXAGON', 'GEM'] as ShapeType[])[Math.floor(Math.random() * 5)]
      });
    }
    return pieces;
  },

  updatePieces: (
    pieces: BallPiece[],
    deltaTime: number,
    gravity: number,
    now: number
  ): BallPiece[] => {
    const dt = deltaTime / 16.67;
    return pieces.filter(p => now - p.startTime < p.duration).map(p => {
      p.vel.y += gravity * dt;
      p.pos.x += p.vel.x * dt;
      p.pos.y += p.vel.y * dt;
      p.angle += p.spin * dt;
      return p;
    });
  },

  drawPieces: (
    ctx: CanvasRenderingContext2D,
    pieces: BallPiece[],
    now: number
  ) => {
    pieces.forEach(p => {
      const elapsed = now - p.startTime;
      const progress = elapsed / p.duration;
      const alpha = 1 - progress;

      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.translate(p.pos.x, p.pos.y);
      ctx.rotate(p.angle);
      ctx.fillStyle = p.color;

      ctx.beginPath();
      ShapeUtils.traceShape(ctx, { x: 0, y: 0 }, p.shape, p.radius);
      ctx.fill();

      ctx.restore();
    });
  }
};
